<template>
  <div>
    <el-checkbox v-model="selColorchecked">选择颜色</el-checkbox>
    <draggable
      v-model="datas"
      class="comp-md-kr-drag-input-group"
      @change="draggableChange"
    >
      <transition-group>
        <div
          v-for="(item, index) in datas"
          :key="getKey(index)"
          class="group-item"
        >
          <div class="group-box left-box">
            <i class="icon iconfont icon-tuozhuaihuise" />
          </div>
          <div v-if="selColorchecked" class="color-picker-wrapper group-box">
            <div class="color-box">
              <div
                class="color-block"
                :style="{
                  background: item.bgColor ? item.bgColor : '#F2F4F6',
                }"
                @click="showColorSel(index)"
              ></div>
              <colorSelect
                v-show="index == colorSetView"
                :inputTagIndex="index"
                @colorselData="getcolorselData"
              />
            </div>
          </div>
          <div
            class="group-box center-box"
            :style="{ marginLeft: selColorchecked ? '10px' : '0' }"
          >
            <el-form-item class="group-box-input">
              <el-input
                v-model="item.label"
                :class="selColorchecked ? 'box-input' : 'box-input2'"
                :disabled="item.uneditable"
                placeholder="请输入显示文本"
                size="medium"
                @input="inputChange"
                @blur="inputBlur"
              />
            </el-form-item>
            <el-form-item class="group-box-input">
              <el-input
                v-model="item.value"
                :class="selColorchecked ? 'box-input' : 'box-input2'"
                :disabled="item.disabled || item.uneditable"
                placeholder="请输入选项编号"
                size="medium"
                @input="inputChange"
                @blur="inputBlur"
              />
            </el-form-item>
          </div>
          <div class="group-box right-box">
            <div class="right-box-inner right-box-inner1">
              <i
                class="icon iconfont icon-addd"
                @click="handelAddButton(index)"
              />
            </div>
            <div class="right-box-inner">
              <i
                v-if="!(item.disabled || item.uneditable)"
                class="icon iconfont icon-shanchu"
                @click="handelRemoveButton(index)"
              />
            </div>
          </div>

          <div>
            <el-dialog
              v-if="dialogVisible"
              title="删除"
              :visible.sync="dialogVisible"
              width="30%"
              :append-to-body="true"
            >
              <span>“{{ info }}”下有数据，确认删除吗？</span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="del()">确 定</el-button>
              </span>
            </el-dialog>
          </div>
          <!-- 快捷创建 -->
          <el-dialog
            v-if="quickCreateDialog"
            :visible="quickCreateDialog"
            @update:visible="quickCreateCancel"
            title="快捷创建"
            width="30%"
            :append-to-body="true"
          >
            <div>请输入选项值和编号（每行一个），编号用英文逗号隔开</div>
            <div>例：选项名称,01</div>
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入内容"
              maxlength="2000"
              v-model="textAreaContent"
            >
            </el-input>
            <span slot="footer" class="dialog-footer">
              <el-button @click="quickCreateCancel()">取 消</el-button>
              <el-button type="primary" @click="quickCreatSure()"
                >确 定</el-button
              >
            </span>
          </el-dialog>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { checkSelectFieldDescribeIsThereData } from '@inv/services/metaData/businessCustomization'
import colorSelect from '@inv/view/metaData/module/components/manageTags/colorSelect'

export default {
  name: 'KrDragInputGroup',
  components: {
    draggable,
    colorSelect,
  },
  props: {
    value: kr.vue.getPropArray(),
    state: kr.vue.getPropString(),
    apiName: kr.vue.getPropString(),
    isRequired: kr.vue.getPropBoolean(),
    // colorPicker: kr.vue.getPropBoolean(),
    quickCreateDialog: kr.vue.getPropBoolean(),
    textArea: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selColorchecked: false,
      showBgColor: true,
      bgColor: '#F2F4F6',
      fields: '',
      info: '',
      dialogVisible: false,
      datas: [],
      isDis: true,
      isMounted: false,
      colorSetView: -1,
      colorselData: '',
      Index: '',
      textAreaContent: '',
      bgColorList: {
        color1: '#F2F4F6',
        color2: '#FDE2E1',
        color3: '#F8E5CE',
        color4: '#FBF1D1',
        color5: '#CCF6F1',
        color6: '#DAF3FD',
        color7: '#E0EAFF',
        color8: '#EBE2FE',
        color9: '#F9EBFF',
      },
    }
  },
  watch: {
    value: {
      handler(val, old) {
        if (val?.length > 0) {
          if (
            (val[0] && val[0].showBgColor && val[0].showBgColor == true) ||
            (val[0] && val[0].showBgColor && val[0].showBgColor == 'true')
          ) {
            this.selColorchecked = true
          } else {
            this.selColorchecked = false
          }
        }

        if ([null, undefined].includes(val) || _.isEqual(val, old)) return

        if (this.state === 'edit' && this.isDis) {
          this.datas = val.map(item => {
            if (this.selColorchecked == true) {
              item.showBgColor = true
            } else {
              item.showBgColor = false
            }
            return {
              ...item,
              disabled: false,
              raw: item.raw || item,
            }
          })
        } else {
          this.datas = [...val]
          this.datas = val.map(item => {
            if (this.selColorchecked == true) {
              item.showBgColor = true
            } else {
              item.showBgColor = false
            }
            return {
              ...item,
              raw: item.raw || item,
            }
          })
        }
        this.isDis = false
      },
      immediate: true,
    },
    selColorchecked: {
      immediate: true,
      handler(newValue, oldValue) {
        this.datas.map(item => {
          if (newValue == true) {
            // this.selColorchecked = true
            item.showBgColor = true
          } else {
            // this.selColorchecked = false
            item.showBgColor = false
          }
        })
        this.$emit('input', [].concat(this.datas))
        console.log('selColorchecked', newValue, oldValue, this.datas)
      },
    },
    quickCreateDialog(v) {
      this.textAreaContent = ''
      // if(v){
      //   if(this.datas && this.datas.length){
      //     this.textAreaContent = this.datas.reduce((res,key) => {
      //       if(key.label || key.value){
      //         return res+`${key.label},${key.value}\n`
      //       }else{
      //         return res
      //       }
      //     },"")
      //   }

      // }
    },
  },
  mounted() {
    this.isMounted = true
  },
  methods: {
    showColorSel(index) {
      //
      if (this.colorSetView == index) {
        this.colorSetView = -1
        return
      }
      this.colorSetView = index
    },
    getcolorselData(clrObg) {
      //默认赋值灰色
      this.datas[clrObg.index].bgColor = clrObg.color || '#F2F4F6'
      this.$emit('input', [].concat(this.datas))
      //
      setTimeout(() => {
        this.colorSetView = -1
      }, 100)
    },
    // 快捷创建
    quickCreatSure() {
      const arr = this.textAreaContent.split('\n')
      const quickDatas = _.cloneDeep(this.datas)
      this.datas.map((item, index) => {
        return item.value === '' && item.label === ''
          ? this.datas.splice(index, 1)
          : this.datas
      })
      this.datas = arr.reduce((res, item) => {
        const itemArr = item.split(',')

        const itemTrue = quickDatas.filter(item => {
          return itemArr[1] === item.value
        })
        return item !== ''
          ? res.concat({
              label: itemArr[0],
              value: itemArr[1] ? itemArr[1] : '',
              random: kr.random.string(),
              bgColor: itemTrue[0] ? itemTrue[0].bgColor : this.bgColor,
              showBgColor: this.selColorchecked ? true : false,
              // disabled: itemTrue[0] ? itemTrue[0].disabled : false,
            })
          : res
      }, this.datas)
      if (this.datas.length === 0) {
        this.datas = quickDatas
      }
      this.inputChange()
      this.quickCreateCancel()
    },
    // 取消快捷创建
    quickCreateCancel(val = false) {
      this.$emit('update:quickCreateDialog', val)
    },
    inputChange() {
      this.$emit('input', [].concat(this.datas))
    },
    getKey(index) {
      let key = index
      if (this.isMounted) {
        key = kr.getId(16)
        this.isMounted = false
      }
      return key
    },
    draggableChange() {
      this.$emit('input', [].concat(this.datas))
    },
    getBaseData() {
      return {
        random: kr.random.string(),
        value: '',
        label: '',
        bgColor: this.bgColor,
        showBgColor: this.showBgColor,
      }
    },
    inputBlur() {},
    handelAddButton(index) {
      const data = this.getBaseData()

      let datanew = JSON.parse(JSON.stringify(data))
      let tempIndex = parseInt(Math.random() * 10) || 1
      datanew = {
        ...datanew,
        bgColor: this.bgColorList['color' + (tempIndex > 9 ? 1 : tempIndex)],
      }

      this.datas.splice(index + 1, 0, datanew)
      this.$emit('input', [].concat(this.datas))
    },
    async handelRemoveButton(index) {
      if (this.datas.length > 1) {
        const current = this.datas[index]
        const isTmp = current && current.random

        let res = null
        if (!isTmp) {
          res = await checkSelectFieldDescribeIsThereData({
            data: {
              objectDescribeApiName: this.$route.params.apiName,
              apiName: this.apiName,
              deleteOptions: current.raw,
            },
          })
        }

        if (res || isTmp) {
          this.datas.splice(index, 1)
          this.$emit('input', [].concat(this.datas))
        } else {
          // this.dialogVisible = true;
          this.Index = index
          // this.info = this.datas[index].label;
          const info = this.datas[index].label
          this.$confirm(`“${info}”下有数据，确认删除吗？`, '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              // this.$message({
              //   type: 'success',
              //   message: '删除成功!'
              // });

              if (this.isRequired) {
                this.$message.error('删除失败，无法删除，“字段名称”为必填')
              } else {
                this.datas.splice(this.Index, 1)
                this.$emit('input', [].concat(this.datas))
              }
            })
            .catch(() => {})
        }
      } else {
        this.$message.warning('最低保留一个选项！')
      }
    },
    async del() {
      if (this.isRequired) {
        this.$message.error('删除失败，无法删除，“字段名称”为必填')
      } else {
        this.datas.splice(this.Index, 1)
        this.$emit('input', [].concat(this.datas))
      }
      this.dialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.comp-md-kr-drag-input-group {
  border: 1px solid #e4e5eb;
  padding: 10px 12px 10px 4px;
  margin-top: 5px;

  .box-input {
    width: 198px;
  }
  .box-input2 {
    width: 216px;
  }
  /deep/.el-input__inner {
    height: 28px;
    line-height: 28px;
  }

  .icon-tuozhuaihuise {
    font-size: 28px;
    color: #000000;
    opacity: 0.2;
  }

  .group-item {
    position: relative;
    font-size: 0;
    height: 28px;
    margin-bottom: 10px;
    display: flex;
  }

  .group-item:last-of-type {
    margin-bottom: 0;
  }

  .left-box {
    color: #525975;
    text-align: center;
    line-height: 20px;
    margin-top: 4px;
  }

  .center-box {
    margin-right: 10px;
    height: 100%;
    font-size: 0;
    display: flex;

    .group-box-input {
      display: inline-block;
      width: 50%;
      flex: 1;
    }

    .color-picker-wrapper {
      min-width: 36px;
      flex-shrink: 0;
      margin-left: 5px;
      margin-right: 5px;
    }

    .group-box-input:first-of-type {
      padding-right: 5px;
    }

    .group-box-input:last-of-type {
      padding-left: 5px;
    }
  }

  .right-box {
    position: absolute;
    top: 0;
    left: 480px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    border: 1px solid #e4e5eb;
    border-radius: 4px;
    background: #f9fafc;
    height: 28px;
  }

  .right-box-inner {
    width: 28px;
    color: #9699ac;
    line-height: 26px;
    padding-left: 6px;
    cursor: pointer;
  }

  .right-box-inner1 {
    border-right: 1px solid #e4e5eb;
  }
  .right-box-inner:hover {
    opacity: 0.7;
  }

  .color-block {
    width: 28px;
    height: 28px;
    background: rgba(242, 244, 246, 100);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    position: relative;
    cursor: pointer;
  }
  .color-block:hover {
    opacity: 0.9;
  }
}
</style>
